import React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import { ALMOST_WHITE, GRAY_CADET_SILVER } from "constants/colors";
import { APP_VERSION } from "constants/globals";
import { getVersionDetails } from "apis/appInfoApi";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      margin: 0,
      padding: 0,
    },
    versionTextLogin: {
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 12,
      color: GRAY_CADET_SILVER,
    },
    versionText: {
      cursor: "default",
      fontSize: "10px",
      fontWeight: "normal",
      fontStyle: "normal",
      fontStretch: "normal",
      lineHeight: "1.2",
      letterSpacing: "0.2px",
      color: ALMOST_WHITE,
      marginLeft: "4px",
    },
  })
);

type Props = {
  isLogin: boolean;
};

const AppVersion = ({ isLogin }: Props) => {
  const classes = useStyles();
  const [backendVersion, setBackendVersion] = React.useState("");

  React.useEffect(() => {
    if (!isLogin) {
      getVersionDetails()
        .then((resp) => {
          if (resp && resp.data) {
            setBackendVersion(resp.data.version);
          }
        })
        .catch((error) => {
          console.error("getVersionDetails", error);
        });
    }
  }, []);

  return (
    <div className={classes.root}>
      {isLogin ? (
        <span className={classes.versionTextLogin}>Versi&oacute;n {APP_VERSION} Marzo 2023</span>
      ) : (
        <span className={classes.versionText}>
          v{APP_VERSION}&nbsp;({backendVersion})
        </span>
      )}
    </div>
  );
};

export default React.memo(AppVersion);
